require('routes/bizumConfirmation/bizumConfirmation.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ utils
const { formatText } = require('core/i18n').i18n;

// @components
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

// @commons
const  { OKBoxTitle } = require('commonsComponents/OKBoxTitle');

class BizumConfirmationStep extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const wizardTitle = formatText('portability-alreadyRegisteredTitle');
        const infoText1 = formatText('portability-alreadyRegisteredText1');
        const infoText2 = formatText('portability-alreadyRegisteredText2')
        const {children} = this.props;

        return (
            <div>
                <div className="bizum-confirmation-wizard-step__data">
                    <div className="bizum-confirmation-wizard-step__heading">
                        <i className="bizum-confirmation-wizard-step__warning-icon"></i>
                        <div className="bizum-confirmation-wizard-step__wizard-title">
                            <OKBoxTitle value={wizardTitle}
                                isNotSeparator={true}>
                            </OKBoxTitle>
                        </div>
                    </div>
                    <BlockInfo>
                        <p>{infoText1}</p><p>{infoText2}</p>
                    </BlockInfo>
                </div>
                <div className="bizum-confirmation-wizard-step__buttons">
                    {children}
                </div>
            </div>
        );
    }
}

BizumConfirmationStep.propTypes = {
    children: PropTypes.object
};

module.exports = BizumConfirmationStep;
